import React from 'react';
import { Box, Text, Flex } from '@chakra-ui/react';
import { CustomButton } from './UI/CustomButton';
import { MdAdd, MdClose } from 'react-icons/md';

interface ExerciseNode {
  id: string;
  label: string;
  children?: ExerciseNode[];
}

interface ExerciseTreePanelProps {
  exerciseData: ExerciseNode[];
  selectedId: string | null;
  onSelect: (id: string | null) => void;
  onAdd: (parentId?: string) => void;
  onRemove: (id: string) => void;
}

const ExerciseTreePanel: React.FC<ExerciseTreePanelProps> = ({ exerciseData, selectedId, onSelect, onAdd, onRemove }) => {
  return (
    <Box w="288px" p={4} overflowY="auto">
      <Text fontSize="18px" fontWeight="500" mb={4}>
        Exercises:
      </Text>
      <CustomButton
        onClick={() => onAdd()}
        visual="subtle"
        w="100%"
        mb={2}
        bg='transparent'
        border="1px solid #383838"
        borderRadius="10px"
        color="#383838"
        fontSize="14px"
        h="34px"
      >
        <MdAdd size='20px' /> Exercise
      </CustomButton>
      {exerciseData.map((exercise) => (
        <Box key={exercise.id}>
          <Flex
            align="center"
            justify="space-between"
            bg="transparent"
            borderRadius="10px"
            px='8px'
            py={2}
            mb={2}
            h="34px"
            border="1px solid #E5E5E5"
            fontSize="14px"
            fontWeight="500"
          >
            <Text fontWeight="bold">{exercise.label}</Text>
            <CustomButton
              onClick={(e) => {
                e.stopPropagation();
                onRemove(exercise.id);
              }}
              visual="ghost"
              w='20px'
              p='0'
              minW='18px'
              h='20px'
            >
              <MdClose size='12px' color="#CDCDCD" style={{ height: '18px', width: '18px' }} />
            </CustomButton>
          </Flex>
          <CustomButton
            onClick={() => onAdd(exercise.id)}
            visual="subtle"
            w="calc(100% - 16px)"
            mb={2}
            ml='16px'
            bg='transparent'
            border="1px solid #383838"
            borderRadius="10px"
            color="#383838"
            fontSize="14px"
            h="34px"
          >
            <MdAdd size='20px' /> Exercise Option
          </CustomButton>
          {exercise.children && exercise.children.map((option) => (
            <Flex
              key={option.id}
              align="center"
              justify="space-between"
              bg={selectedId === option.id ? '#F7F7F7' : 'transparent'}
              borderRadius="10px"
              px='8px'
              py={2}
              mb={2}
              w="calc(100% - 16px)"
              ml='16px'
              h="34px"
              border="1px solid #E5E5E5"
              fontSize="14px"
              fontWeight="500"
              onClick={() => onSelect(option.id)}
            >
              <Text>{option.label}</Text>
              <CustomButton
                onClick={(e) => {
                  e.stopPropagation();
                  onRemove(option.id);
                }}
                visual="ghost"
                w='20px'
                p='0'
                minW='12px'
                minH='12px'
                h='20px'
              >
                <MdClose size='12px' color="#CDCDCD" style={{ height: '18px', width: '18px' }} />
              </CustomButton>
            </Flex>
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default ExerciseTreePanel; 